import { render, staticRenderFns } from "./MoneyPlacementSearchForm.vue?vue&type=template&id=2ed5d61a&"
import script from "./MoneyPlacementSearchForm.vue?vue&type=script&lang=js&"
export * from "./MoneyPlacementSearchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports